























import { Vue, Component, Watch } from 'vue-property-decorator'
import ResforForm from '@/UI/Auction/PersonalData/ResforForm.vue'
import { PersonalData } from '@/Infrastructure/Store/Auction/PersonalData'
import { RepresentationData } from '@/Infrastructure/Store/Auction/RepresentationData'
import RepresentationForm from '@/UI/Auction/PersonalData/RepresentationForm.vue'
import PersonalDataForm from '@/UI/Auction/PersonalData/PersonalDataForm.vue'
import { namespace } from 'vuex-class'
import { StepValidation } from '@/UI/Shared/StepValidation'
import { AccountId } from '@/Domain/Account'

const auctionStore = namespace('auction')
const accountStore = namespace('account')
const requiredPersonalFields = ['name', 'nif', 'streetType', 'street', 'postalCode', 'province', 'county', 'phone', 'email']
const requiredRepresentationFields = ['name', 'nif']

@Component({
  components: { ResforForm, PersonalDataForm, RepresentationForm }
})
export default class PersonalDataLayout extends Vue {
  formDisabled = true

  @accountStore.Getter
  public accountId!: string

  @auctionStore.Getter
  public representationData!: RepresentationData

  @auctionStore.Getter
  public personalData!: PersonalData

  @auctionStore.Action
  public setRepresentationData!: (representationData: RepresentationData) => void

  @auctionStore.Action
  public setPersonalData!: (personalData: PersonalData) => void

  get isPersonalDataValid (): boolean {
    if (!this.personalData) {
      return false
    }
    let isDataValid = true
    for (const key of requiredPersonalFields) {
      const itemKey = key as keyof PersonalData
      isDataValid = isDataValid && this.personalData[itemKey] !== ''
    }
    return isDataValid
  }

  get isAccountIdIncluded (): boolean {
    if (this.personalData.nif === this.accountId) {
      return true
    }
    if (this.representationData.nif === this.accountId) {
      return true
    }
    return false
  }

  private validateCompanyData (): boolean {
    const accountId = new AccountId(this.personalData.nif)
    if (accountId.isCompany()) {
      return true
    }
    return this.personalData.firstSurname !== ''
  }

  get isRepresentationDataValid (): boolean {
    if (!this.representationData) {
      return false
    }
    if (this.representationData.name === '' && this.representationData.firstSurname === '' &&
      this.representationData.secondSurname === '' && this.representationData.nif === '') {
      return true
    }
    let isDataValid = true
    for (const key of requiredRepresentationFields) {
      const itemKey = key as keyof RepresentationData
      isDataValid = isDataValid && this.representationData[itemKey] !== ''
    }
    return isDataValid && this.validateRepresentationCompanyData()
  }

  private validateRepresentationCompanyData (): boolean {
    const accountId = new AccountId(this.representationData.nif)
    if (accountId.isCompany()) {
      return true
    }
    return this.representationData.firstSurname !== ''
  }

  get validateFields (): StepValidation {
    const isDataValid = this.isPersonalDataValid && this.isRepresentationDataValid && this.isAccountIdIncluded
    return {
      validForm: isDataValid,
      step: 1
    }
  }

  @Watch('validateFields')
  onValidForm (newValue: StepValidation): void {
    this.$emit('validForm', newValue)
  }

  onRepresentationDataUpdated ($event: RepresentationData): void {
    this.setRepresentationData($event)
  }

  onPersonalDataUpdated ($event: PersonalData): void {
    this.setPersonalData($event)
  }
}
